import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { RenderDatePicker, SelectInput } from 'components/Common/Inputs';
import AutoCompleteInput from 'components/Common/Inputs/AutoCompleteInput';
import { toastr } from 'react-redux-toastr';
import moment from 'moment';

class AddCustomerAccountForm extends Component {
  static propTypes = {
    onConfirmAccountLink: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      customerId: '',
      validFrom: null,
      validUntil: null,
      capacity: null,
      accountNumber: null
    };

    this.onDataInputChange = this.onDataInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleDateFromChange(newValue) {
    this.setState({ validFrom: newValue });
  }

  handleSubmit(event) {
    event.preventDefault();
    const { customerId, validUntil, accountNumber, capacity } = this.state;
    let { validFrom } = this.state;
    validFrom = validFrom == null ? moment().format('MMM DD, YYYY') : validFrom;
    const customerAccount = { customerId, validFrom, validUntil, capacity, accountNumber };
    const { onConfirmAccountLink } = this.props;

    if (!accountNumber || !validFrom) {
      toastr.error('', 'Please provide Account Number.');
      return;
    }

    onConfirmAccountLink(customerAccount);
    this.setState({
      customerId: '',
      validFrom: null,
      validUntil: null,
      capacity: null,
      accountNumber: null
    });
  }

  onAccountNumberSelectedItem = lookupValue => this.setState({ accountNumber: lookupValue });

  onDataInputChange(event) {
    const { target: { name, value } } = event;
    this.setState({ [name]: value });
  }

  render() {
    const { validFrom, accountNumber, capacity } = this.state;
    return (
      <div className="panel-body">
        <form onSubmit={ this.handleSubmit }>
          <table>
            <tbody>
              <tr>
                <td>
                  <div>
                    <label
                      htmlFor="account_number"
                      className="panel-body-label"
                      id="account-number-name"
                    >
                      Account Number
                    </label>
                  </div>
                </td>
                <td>
                  <AutoCompleteInput
                    id="account-number"
                    name="accountNumber"
                    category="account"
                    placeholder="Enter account number..."
                    className="form-select"
                    required
                    value={ accountNumber || '' }
                    onSelectedItem={ lookupValue => this.onAccountNumberSelectedItem(lookupValue) }
                  />
                </td>
              </tr>
              <tr>
                <td>
                  <label
                    htmlFor="capacity"
                    className="panel-body-label"
                    id="account-capacity-name"
                  >
                    Capacity
                  </label>
                </td>
                <td>
                  <Field
                    id="account-capacity"
                    component={ SelectInput }
                    name="capacity"
                    className="form-select"
                    onChange={ this.onDataInputChange }
                    value={ capacity }
                  >
                    <option value="" disabled>Select capacity from dropdown</option>
                    <option value="0">Beneficial Owner</option>
                    <option value="1">Account Holder</option>
                    <option value="2">Intermediary</option>
                    <option value="3">Introducer Financial</option>
                    <option value="4">Introducer Non Financial</option>
                    <option value="5">Guarantor</option>
                    <option value="6">Trustee</option>
                    <option value="7">Attorney in Fact</option>
                  </Field>
                </td>
              </tr>
              <tr>
                <td>
                  <label
                    htmlFor="valid_from"
                    className="panel-body-label"
                    id="account-effective-date-name"
                  >
                    Effective Date
                  </label>
                </td>
                <td className="full-width-datepicker">
                  <Field
                    id="account-effective-date"
                    component={ RenderDatePicker }
                    name="validFrom"
                    className="form-input"
                    placeholder="MMM DD, YYYY"
                    required
                    onChange={ (e, date) => this.handleDateFromChange(date) }
                    value={ validFrom }
                  />
                </td>
              </tr>
              <tr>
                <td>&nbsp;</td>
                <td>
                  <button
                    id="link-account-btn"
                    className="btn btn-primary"
                    type="submit"
                  >Link Account</button>
                </td>
              </tr>
            </tbody>
          </table>
        </form>
      </div>
    );
  }
}

export default reduxForm({
  form: 'addCustomerAccountForm'
})(AddCustomerAccountForm);
